import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { logoUrl } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0B2E4B]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-3">
            <div className="h-16 md:h-20 w-48 md:w-56 overflow-hidden flex items-center justify-center">
              <img 
                src={logoUrl} 
                alt="BrightCore PR" 
                className="h-32 md:h-40 object-contain scale-150"
              />
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10">
            <button
              onClick={() => scrollToSection('services')}
              className="text-white/80 hover:text-white transition-colors duration-300 text-base font-medium"
            >
              {t.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-white/80 hover:text-white transition-colors duration-300 text-base font-medium"
            >
              {t.nav.portfolio}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white/80 hover:text-white transition-colors duration-300 text-base font-medium"
            >
              {t.nav.contact}
            </button>
          </nav>

          {/* Language Toggle & Mobile Menu */}
          <div className="flex items-center gap-2">
            <button
              onClick={() => language === 'es' && toggleLanguage()}
              className={`px-3 py-1.5 text-sm font-medium rounded transition-all duration-300 ${
                language === 'es' 
                  ? 'bg-transparent text-white/60' 
                  : 'bg-[#28BBC5] text-white'
              }`}
            >
              ENG
            </button>
            <button
              onClick={() => language === 'en' && toggleLanguage()}
              className={`px-3 py-1.5 text-sm font-medium rounded transition-all duration-300 ${
                language === 'en' 
                  ? 'bg-transparent text-white/60' 
                  : 'bg-[#28BBC5] text-white'
              }`}
            >
              ESP
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-white ml-2"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 right-0 bg-[#0B2E4B]/98 backdrop-blur-md border-b border-white/10 py-6">
            <nav className="flex flex-col items-center gap-6">
              <button
                onClick={() => scrollToSection('services')}
                className="text-white/80 hover:text-white transition-colors duration-300 text-lg"
              >
                {t.nav.services}
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="text-white/80 hover:text-white transition-colors duration-300 text-lg"
              >
                {t.nav.portfolio}
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white/80 hover:text-white transition-colors duration-300 text-lg"
              >
                {t.nav.contact}
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
